import { Style, Stroke, Circle, Fill } from 'ol/style'

// 在initHighlightLayer中添加
// vectorStyle.js 修改后
export function vectorStyle(feature) {
  const geomType = feature.getGeometry().getType()

  if (geomType === 'Point') {
    return new Style({
      image: new Circle({
        radius: 10,
        fill: new Fill({ color: 'rgba(255, 0, 0, 0.8)' }),
        stroke: new Stroke({ color: '#fff', width: 2 }),
        offsetX: -20,
      }),
    })
  }

  return new Style({
    stroke: new Stroke({
      color: 'rgba(0, 0, 0, 1)',
      width: 4,
    }),
  })
}
